// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background: linear-gradient(90deg, var(--ion-color-primary-shade-dark) 0%, var(--ion-color-secondary) 100%);
  position: fixed;
  bottom: 0;
  width: 100%;
  color: var(--ion-color-secondary-contrast);
  font-size: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding-inline: 15px;
  padding-block: 2px;
}

a {
  cursor: pointer;
}

ion-button {
  color: var(--ion-color-secondary-contrast);
  --border-color: var(--ion-color-secondary-contrast);
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 10px;
}
ion-button ion-icon {
  font-size: 22px;
  margin-inline-end: 8px;
}

p {
  margin: 0;
}

.info {
  display: flex;
  align-items: center;
  gap: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/footer-dp/footer-dp.component.scss","webpack://./src/components/general%20components/footer-dp/footer-dp.component.scss"],"names":[],"mappings":"AAAA;EACE,2GAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,0CAAA;EACA,mDAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;ACCF;ADCE;EACE,eAAA;EACA,sBAAA;ACCJ;;ADGA;EACE,SAAA;ACAF;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ACAF","sourcesContent":["footer {\n  background: linear-gradient(90deg, var(--ion-color-primary-shade-dark) 0%, var(--ion-color-secondary) 100%);\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  color: var(--ion-color-secondary-contrast);\n  font-size: 10px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-inline: 15px;\n  padding-block: 2px;\n}\n\na {\n  cursor: pointer;\n}\n\nion-button {\n  color: var(--ion-color-secondary-contrast);\n  --border-color: var(--ion-color-secondary-contrast);\n  --border-style: solid;\n  --border-width: 1px;\n  --border-radius: 10px;\n\n  ion-icon {\n    font-size: 22px;\n    margin-inline-end: 8px;\n  }\n}\n\np {\n  margin: 0;\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}","footer {\n  background: linear-gradient(90deg, var(--ion-color-primary-shade-dark) 0%, var(--ion-color-secondary) 100%);\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  color: var(--ion-color-secondary-contrast);\n  font-size: 10px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-inline: 15px;\n  padding-block: 2px;\n}\n\na {\n  cursor: pointer;\n}\n\nion-button {\n  color: var(--ion-color-secondary-contrast);\n  --border-color: var(--ion-color-secondary-contrast);\n  --border-style: solid;\n  --border-width: 1px;\n  --border-radius: 10px;\n}\nion-button ion-icon {\n  font-size: 22px;\n  margin-inline-end: 8px;\n}\n\np {\n  margin: 0;\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
